import { LogoText } from "../../../../assets/icons";
import { cn } from "../../../../util/classNameConstructor";
import Button from "../../../core/button/Button";
import Icon from "../../../core/icon/Icon";
import { IconName } from "../../../core/icon/names";

interface MessageProps {
  text?: string;
  error?: boolean;
  success?: boolean;
  icon?: IconName;
  children?: React.ReactNode;
  action?: {
    text: string;
    onClick: () => void;
  };
}
const Message = ({
  text,
  error,
  success,
  icon,
  action,
  children,
}: MessageProps) => {
  return (
    <div className="flex flex-col items-center gap-5 text-center">
      <div className="flex flex-col items-center gap-2">
        <Icon
          name={error ? "x-md" : success ? "checkmark-md" : icon || "alert"}
          className={cn(
            "h-12 w-12",
            error
              ? "text-icon-critical"
              : success
              ? "text-icon-success"
              : "text-icon-default"
          )}
        />
        {text && <span className="heading-xl text-text-subdued">{text}</span>}
      </div>
      {children}
      {action && (
        <Button
          variant="primary"
          {...action}
        />
      )}
    </div>
  );
};
interface AuthPageWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  message?: MessageProps;
}
export const AuthPageWrapper = ({
  children,
  className,
  message,
}: AuthPageWrapperProps) => {
  return (
    <div className="bg-background-default inset-0 flex min-h-screen w-screen flex-col items-center justify-center gap-10 p-10">
      <div
        className={cn(
          "bg-surface-default flex min-w-[360px] max-w-md flex-col items-center gap-10 rounded-3xl p-10 shadow-xl",
          className
        )}
      >
        {message?.error || message?.success || message?.text ? (
          <Message {...message} />
        ) : (
          children
        )}
      </div>
      <div className="[&_svg_path]:fill-border-default h-12 w-12">
        <LogoText />
      </div>
    </div>
  );
};
